import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import DashboardLayout from './components/DashboardLayout';
import ClearanceFiles from './components/ClearanceFiles';
import ShipmentTracking from './components/ShipmentTracking';
import CustomsTariffs from './components/CustomsTariffs';
import Messages from './components/Messages';
import Users from './components/Users';
import ActivityMonitor from './components/ActivityMonitor';
import './styles/nassar-theme.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('nassar_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0e2a59 0%, #03428d 50%, #03a9b3 100%)'
      }}>
        <div className="spinner" style={{ width: '60px', height: '60px', borderTopColor: 'white' }}></div>
      </div>
    );
  }

  return (
    <Router basename='/'>
      <Routes>
        {/* Login Route */}
        <Route 
          path="/" 
          element={
            isAuthenticated ? 
              <Navigate to="/dashboard/clearance-files" replace /> : 
              <AdminLogin setIsAuthenticated={setIsAuthenticated} />
          } 
        />

        {/* Dashboard Routes */}
        <Route 
          path="/dashboard" 
          element={
            isAuthenticated ? 
              <DashboardLayout /> : 
              <Navigate to="/" replace />
          }
        >
          <Route path="clearance-files" element={<ClearanceFiles />} />
          <Route path="shipment-tracking" element={<ShipmentTracking />} />
          <Route path="customs-tariffs" element={<CustomsTariffs />} />
          <Route path="messages" element={<Messages />} />
          <Route path="activity-monitor" element={<ActivityMonitor />} />
          <Route path="users" element={<Users />} />
          <Route index element={<Navigate to="clearance-files" replace />} />
        </Route>

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
